import { render } from "./Verify.vue?vue&type=template&id=53a886f7&ts=true"
import script from "./Verify.vue?vue&type=script&lang=ts"
export * from "./Verify.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__